module.exports = __webpack_public_path__ + "img/entrustOrder.29a3ecf9.jpg";